/* Live 5AM — Quiz V2
 * Slide navigation, dimension-based scoring, ungated results,
 * optional Shopify customer email capture, conditional doctor/safety note.
 */
(function () {
  if (window.__quizV2Initialized) return;
  window.__quizV2Initialized = true;

  var TAG_BY_TYPE = {
    steady: 'quiz-steady-pace',
    morning: 'quiz-morning-pace',
    pressure: 'quiz-pressure-pace',
    quiet: 'quiz-quiet-pace',
    reset: 'quiz-reset-pace',
  };

  var LABEL_BY_TYPE = {
    steady: 'Steady Pace',
    morning: 'Morning Pace',
    pressure: 'Pressure Pace',
    quiet: 'Quiet Pace',
    reset: 'Reset Pace',
  };

  // ── Gate teaser copy (pre-approved; no product/health claims) ──────
  var GATE_HEADLINE_BY_TYPE = {
    steady: "You're running a Steady Pace",
    morning: "You're running a Morning Pace",
    pressure: "You're running a Pressure Pace",
    quiet: "You're running a Quiet Pace",
    reset: "You're running on empty",
  };
  var GATE_SUBLINE_BY_TYPE = {
    steady: "You're ahead, and there's a simple way to protect that.",
    morning: "Strong mornings, heavy afternoons, and it's fixable.",
    pressure: "High stress tends to show up in your body first.",
    quiet: "Sleep is the lever, and it's the right place to focus.",
    reset: "The honest first step here is not a supplement.",
  };

  // ── Dimension-based scoring ──────────────────────────────────────
  var SCORE_DIMS = ['chrono', 'stress', 'sleep', 'deplete', 'mood', 'apnea'];
  function parseScore(str) {
    var out = {};
    (str || '').trim().split(/\s+/).forEach(function (tok) {
      if (!tok) return;
      var p = tok.split(':');
      if (p.length === 2) { var v = parseInt(p[1], 10); if (!isNaN(v)) out[p[0]] = (out[p[0]] || 0) + v; }
    });
    return out;
  }
  function tallyScores(rs) {
    var t = { chrono: 0, stress: 0, sleep: 0, deplete: 0, mood: 0, apnea: 0 };
    rs.forEach(function (r) { var s = parseScore(r.score); SCORE_DIMS.forEach(function (d) { if (s[d]) t[d] += s[d]; }); });
    return t;
  }
  function classifyPace(t) {
    var friction = t.stress + t.sleep + t.deplete;
    if (t.deplete >= 3 || (t.deplete >= 2 && friction >= 6)) return 'reset';
    if (t.stress >= 2 && t.stress >= t.sleep && t.stress >= t.deplete) return 'pressure';
    if (t.sleep >= 2 && t.sleep >= t.stress) return 'quiet';
    if (t.chrono > 0 && t.deplete >= 1) return 'morning';
    if (friction <= 2) return 'steady';
    if (t.stress >= t.sleep && t.stress >= t.deplete) return 'pressure';
    if (t.sleep >= t.deplete) return 'quiet';
    return t.chrono > 0 ? 'morning' : 'reset';
  }

  // Map our quiz events to Meta + GA4 event names.
  // Standard events (Lead, AddToCart, generate_lead, add_to_cart) are recognized
  // by ad platforms for optimization. Custom events are for funnel analysis.
  var EVENT_MAP = {
    quiz_v2_started: {
      meta: { type: 'trackCustom', name: 'QuizStarted' },
      ga: { name: 'quiz_started' },
    },
    quiz_v2_question_answered: {
      meta: { type: 'trackCustom', name: 'QuizQuestionAnswered' },
      ga: { name: 'quiz_question_answered' },
    },
    quiz_v2_lead_captured: {
      meta: { type: 'track', name: 'Lead' }, // STANDARD Meta event
      ga: { name: 'generate_lead' }, // STANDARD GA4 event
    },
    quiz_v2_completed: {
      meta: { type: 'trackCustom', name: 'QuizCompleted' },
      ga: { name: 'quiz_completed' },
    },
    quiz_v2_bundle_added: {
      meta: { type: 'track', name: 'AddToCart' }, // STANDARD Meta event
      ga: { name: 'add_to_cart' }, // STANDARD GA4 event
    },
  };

  // Publish to Shopify's Customer Events bus + forward to Meta Pixel + GA4.
  function track(name, payload) {
    payload = payload || {};

    // 1. Shopify Customer Events bus (so future Custom Pixels can listen)
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (_) {}

    var mapping = EVENT_MAP[name];
    if (!mapping) return;

    // 2. Meta Pixel (loaded by Facebook & Instagram channel app)
    try {
      if (typeof window.fbq === 'function') {
        window.fbq(mapping.meta.type, mapping.meta.name, payload);
      }
    } catch (_) {}

    // 3. GA4 via gtag (loaded by Google & YouTube channel app)
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', mapping.ga.name, payload);
      }
    } catch (_) {}
  }

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    var slides = Array.prototype.slice.call(document.querySelectorAll('[data-quiz-v2-slide]'));
    if (slides.length === 0) return;

    // Inject animations
    if (!document.getElementById('quiz-v2-styles')) {
      var style = document.createElement('style');
      style.id = 'quiz-v2-styles';
      style.textContent =
        '@keyframes quizV2In{from{transform:translateX(40px);opacity:0}to{transform:translateX(0);opacity:1}}' +
        '@keyframes quizV2InBack{from{transform:translateX(-40px);opacity:0}to{transform:translateX(0);opacity:1}}' +
        '@keyframes quizV2Shake{0%,100%{transform:translateX(0)}20%{transform:translateX(-6px)}40%{transform:translateX(6px)}60%{transform:translateX(-4px)}80%{transform:translateX(4px)}}' +
        '.quiz-v2-in{animation:quizV2In .38s cubic-bezier(.22,1,.36,1) both}' +
        '.quiz-v2-in-back{animation:quizV2InBack .38s cubic-bezier(.22,1,.36,1) both}' +
        '.quiz-v2-cta{display:flex;flex-direction:column;gap:12px;align-items:center;margin-top:24px}' +
        '.quiz-v2-cta-secondary{color:#0C2421;text-decoration:underline;font-family:Outfit,Poppins,sans-serif;font-size:14px}' +
        '.quiz-v2-consent{display:flex;gap:8px;align-items:flex-start;font-family:Poppins,sans-serif;font-size:13px;color:#545454;margin:0 0 16px;cursor:pointer}' +
        '.quiz-v2-consent input{flex-shrink:0;margin-top:2px}' +
        '.quiz-v2-error{color:#FF4444;font-size:14px;text-align:center;margin:8px 0;font-family:Poppins,sans-serif}' +
        // Ensure the conditional safety note truly hides when it has [hidden]
        // (a class-based display rule otherwise overrides the bare attribute).
        '.quiz-v2-doctor-note[hidden]{display:none !important}' +
        // ── Animated "Building your Pace" loader ──
        '.quiz-v2-loader{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:22px;min-height:56vh;text-align:center;padding:32px 20px;font-family:Poppins,sans-serif}' +
        '.qvl-ring{position:relative;width:140px;height:140px}' +
        '.qvl-ring-svg{width:140px;height:140px;transform:rotate(-90deg)}' +
        '.qvl-ring-bg{fill:none;stroke:#E9EEEC;stroke-width:6}' +
        '.qvl-ring-fg{fill:none;stroke:#F26522;stroke-width:6;stroke-linecap:round;stroke-dasharray:327;stroke-dashoffset:327;animation:qvlFill 3s cubic-bezier(.5,0,.2,1) forwards}' +
        '@keyframes qvlFill{to{stroke-dashoffset:0}}' +
        '.qvl-ring-core{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:34px;font-weight:700;color:#0C2421;letter-spacing:-1px;animation:qvlPulse 1.6s ease-in-out infinite}' +
        '@keyframes qvlPulse{0%,100%{transform:scale(1)}50%{transform:scale(1.06)}}' +
        '.qvl-ring-core span{font-size:15px;margin-left:1px;color:#F26522}' +
        '.qvl-title{font-size:20px;font-weight:600;color:#0C2421;margin:0}' +
        '.qvl-steps{list-style:none;padding:0;margin:0;display:flex;flex-direction:column;gap:13px;text-align:left}' +
        '.qvl-steps li{display:flex;align-items:center;gap:11px;font-size:15px;color:#9aa8a3;opacity:.45;transition:opacity .4s ease,color .4s ease}' +
        '.qvl-steps li.active{opacity:1;color:#0C2421}' +
        '.qvl-check{width:21px;height:21px;border-radius:50%;border:2px solid #cbd6d2;display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;transition:border-color .3s,background .3s}' +
        '.qvl-steps li.done .qvl-check{background:#F26522;border-color:#F26522}' +
        '.qvl-steps li.done .qvl-check::after{content:"";width:5px;height:9px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg);margin-top:-2px}' +
        '.qvl-thumbs{display:flex;gap:10px;margin-top:4px;flex-wrap:wrap;justify-content:center;max-width:340px}' +
        '.qvl-thumb{width:46px;height:46px;border-radius:12px;object-fit:cover;background:#F6F8F7;opacity:0;transform:translateY(10px) scale(.88);animation:qvlPop .5s cubic-bezier(.22,1,.36,1) forwards;animation-delay:calc(1.5s + var(--i) * .16s);box-shadow:0 4px 14px rgba(12,36,33,.09)}' +
        '@keyframes qvlPop{to{opacity:1;transform:translateY(0) scale(1)}}' +
        '@media(prefers-reduced-motion:reduce){.qvl-ring-fg{animation-duration:.01s}.qvl-ring-core{animation:none}.qvl-thumb{animation-duration:.01s}}';
      document.head.appendChild(style);
    }

    // Build navigable list: questions + loading. Results are revealed after loading.
    var questionSlides = slides.filter(function (s) { return s.dataset.slideType === 'question'; });
    var loadingSlide = slides.filter(function (s) { return s.dataset.slideType === 'loading'; })[0];
    var resultSlides = slides.filter(function (s) { return s.dataset.slideType === 'result'; });

    // Hide all initially, then show first question
    slides.forEach(function (s) { s.style.display = 'none'; });
    var sequence = questionSlides.concat(loadingSlide ? [loadingSlide] : []);
    if (sequence.length === 0) return;
    sequence[0].style.display = '';

    var currentIndex = 0;
    var navLocked = false;
    var formSubmitted = false;
    var resultRevealed = false;
    var gateSubmitted = false; // guards the gate lead capture from double-firing
    var resultShown = false;   // guards the full result reveal from running twice
    var responses = []; // [{ qid, question, answer, score }]

    // Computed once when reaching the loading slide, shared with submit + reveal.
    var paceType = 'steady';
    var tag = TAG_BY_TYPE.steady;
    var note = '';
    var moodFlag = false;
    var apneaFlag = false;

    var quizHeader = document.querySelector('.quiz-header');
    var quizProgressBar = document.querySelector('.quiz-progress-bar');
    var progressContent = document.querySelector('.quiz-progress-content');
    var progressNum = document.querySelector('.quiz-progress-number');
    var backArrow = document.querySelector('.quiz-back-svg');

    function totalProgressSlides() {
      // Progress is measured across the questions only.
      return questionSlides.length;
    }

    function updateChrome() {
      var loadingIdx = loadingSlide ? sequence.indexOf(loadingSlide) : -1;
      var onLoadingOrAfter = loadingIdx !== -1 && currentIndex >= loadingIdx;
      if (quizHeader) quizHeader.style.display = onLoadingOrAfter ? 'none' : '';
      if (quizProgressBar) quizProgressBar.style.display = onLoadingOrAfter ? 'none' : '';
      // Back arrow: hide on first slide AND once we reach loading / result.
      if (backArrow) {
        backArrow.style.display = (currentIndex === 0 || onLoadingOrAfter) ? 'none' : '';
      }

      if (progressNum) {
        var visibleTotal = totalProgressSlides();
        var visibleCurrent = Math.min(currentIndex + 1, visibleTotal);
        progressNum.textContent = visibleCurrent + ' / ' + visibleTotal;
      }
      if (progressContent) {
        var maxIdx = totalProgressSlides() - 1;
        var clamped = Math.min(currentIndex, maxIdx);
        var pct = maxIdx === 0 ? 100 : (clamped / maxIdx) * 100;
        progressContent.style.position = 'relative';
        progressContent.style.overflow = 'hidden';
        var fill = progressContent.querySelector('.quiz-progress-fill');
        if (!fill) {
          fill = document.createElement('div');
          fill.className = 'quiz-progress-fill';
          fill.style.cssText = 'position:absolute;top:0;left:0;height:100%;width:0%;background:linear-gradient(0deg,#00AEEF 0%,#00AEEF 100%);border-radius:36px;transition:width .4s ease;z-index:0';
          progressContent.insertBefore(fill, progressContent.firstChild);
        }
        Array.prototype.slice.call(progressContent.children).forEach(function (c) {
          if (!c.classList.contains('quiz-progress-fill')) {
            c.style.position = 'relative';
            c.style.zIndex = '1';
          }
        });
        fill.style.width = pct + '%';
      }
    }

    function computeResult() {
      var totals = tallyScores(responses);
      paceType = classifyPace(totals);
      tag = TAG_BY_TYPE[paceType] || TAG_BY_TYPE.steady;
      note = buildNote(responses, totals, paceType);
      moodFlag = totals.mood >= 2;
      apneaFlag = totals.apnea >= 1;
    }

    // Staged "Building your Pace" loader: light up each step, then reveal.
    function runLoaderSequence(loadingEl) {
      var steps = loadingEl.querySelectorAll('.qvl-steps li');
      var startTimes = [150, 1050, 2050];
      steps.forEach(function (li, i) {
        var t = startTimes[i] != null ? startTimes[i] : 150 + i * 900;
        setTimeout(function () { li.classList.add('active'); }, t);
        setTimeout(function () { li.classList.add('done'); }, t + 750);
      });
      setTimeout(function () { revealGate(loadingEl); }, 3300);
    }

    // ── Email-capture gate ─────────────────────────────────────────
    // Shown once the loader finishes. Teaser uses the already-computed pace type.
    // Submit fires the Klaviyo capture (moved here from the old results form) and
    // then reveals the full result; Skip reveals the result with no capture.
    function revealGate(loadingEl) {
      var gateEl = loadingEl.querySelector('[data-quiz-v2-gate]');
      if (!gateEl) { revealResult(paceType); return; } // fail-open: never trap the user
      var loaderEl = loadingEl.querySelector('.quiz-v2-loader');
      if (loaderEl) loaderEl.style.display = 'none';

      var h = gateEl.querySelector('[data-quiz-v2-gate-headline]');
      var s = gateEl.querySelector('[data-quiz-v2-gate-sub]');
      if (h) h.textContent = GATE_HEADLINE_BY_TYPE[paceType] || GATE_HEADLINE_BY_TYPE.steady;
      if (s) s.textContent = GATE_SUBLINE_BY_TYPE[paceType] || GATE_SUBLINE_BY_TYPE.steady;

      // Carry the computed tag/note onto the hidden contact fields.
      var tagsInput = gateEl.querySelector('[data-quiz-v2-tags]');
      var noteInput = gateEl.querySelector('[data-quiz-v2-note]');
      if (tagsInput) tagsInput.value = tag;
      if (noteInput) noteInput.value = note;

      gateEl.removeAttribute('hidden');
      gateEl.style.display = '';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { gateEl.classList.add('quiz-v2-in'); });
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });

      var emailInput = gateEl.querySelector('[data-quiz-v2-email]');
      if (emailInput) { try { emailInput.focus({ preventScroll: true }); } catch (_) {} }
    }

    // Fire the lead capture that used to live on the results form.
    function captureLead(gateEl, name, email) {
      try {
        localStorage.setItem('quizV2Submission', JSON.stringify({
          name: name, email: email, paceType: paceType, tag: tag,
          submittedAt: new Date().toISOString(), responses: responses,
        }));
      } catch (_) {}

      // Meta "Lead" + GA4 "generate_lead"
      track('quiz_v2_lead_captured', { pace_type: paceType, tag: tag, email: email, name: name });

      // ── Klaviyo: identify the profile + fire the quiz-completion event.
      // This is the trigger for the Klaviyo "Quiz Results" flow; pace_type rides
      // as both an event and a profile property for a trigger-time split.
      try {
        var kl = (window.klaviyo = window.klaviyo || []);
        var paceLabel = LABEL_BY_TYPE[paceType] || '';
        kl.push(['identify', { '$email': email, '$first_name': name, 'pace_type': paceType, 'pace_type_label': paceLabel }]);
        kl.push(['track', 'Completed Energy Quiz', { pace_type: paceType, pace_type_label: paceLabel, quiz_version: 'v2' }]);
      } catch (_) {}

      // ── Klaviyo: subscribe the profile to the master list (records CASL consent).
      // Public Client Subscribe API (company_id only, no private key) — safe from the
      // browser. Fire-and-forget: never awaited so the result reveal is not delayed.
      try {
        var profileAttrs = {
          email: email,
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
        };
        if (name) { profileAttrs.first_name = name; }
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=Xrafig', {
          method: 'POST',
          headers: { 'revision': '2025-07-15', 'Content-Type': 'application/json' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Energy Quiz',
                profile: { data: { type: 'profile', attributes: profileAttrs } },
              },
              relationships: { list: { data: { type: 'list', id: 'Rrr3iJ' } } },
            },
          }),
        }).catch(function (err) { console.error('[quiz-v2] Klaviyo subscribe failed', err); });
      } catch (_) {}

      // Create the Shopify customer (tags + note) in the background so revealing
      // the result never waits on the network. Fire-and-forget by design.
      var form = gateEl.querySelector('form.quiz-v2-customer-form');
      if (form && form.action) {
        try {
          var ajaxParams = new URLSearchParams();
          new FormData(form).forEach(function (v, k) {
            if (k === 'form_key') return; // Shopify Forms marker that strips tags/note
            ajaxParams.append(k, v);
          });
          fetch(form.action, {
            method: 'POST',
            body: ajaxParams.toString(),
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
              'Accept': 'application/json, text/javascript, */*; q=0.01',
              'X-Requested-With': 'XMLHttpRequest',
            },
          }).catch(function (err) { console.error('[quiz-v2] gate /contact failed', err); });
        } catch (_) {}
      }
    }

    // Gate: primary "Show my full result" submit.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.quiz-v2-gate-submit');
      if (!btn) return;
      e.preventDefault();
      var gateEl = btn.closest('[data-quiz-v2-gate]');
      if (!gateEl) return;

      var emailInput = gateEl.querySelector('[data-quiz-v2-email]');
      var nameInput = gateEl.querySelector('[data-quiz-v2-name]');
      var errEl = gateEl.querySelector('[data-quiz-v2-gate-error]');
      var email = emailInput ? emailInput.value.trim() : '';
      var name = nameInput ? nameInput.value.trim() : '';

      if (!email || !EMAIL_RE.test(email)) {
        if (emailInput) {
          emailInput.style.borderColor = '#FF4444';
          emailInput.style.animation = 'none';
          setTimeout(function () { emailInput.style.animation = 'quizV2Shake 0.3s ease'; }, 10);
          try { emailInput.focus(); } catch (_) {}
        }
        if (errEl) { errEl.textContent = 'Please enter a valid email address.'; errEl.hidden = false; errEl.style.display = ''; }
        return;
      }

      if (gateSubmitted) return;
      gateSubmitted = true;
      captureLead(gateEl, name, email);
      revealResult(paceType);
    });

    // Gate: "No thanks, just show my result." — reveal with no capture.
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-quiz-v2-gate-skip]')) return;
      e.preventDefault();
      track('quiz_v2_gate_skipped', { pace_type: paceType }); // analytics only; non-blocking
      revealResult(paceType);
    });

    // Gate: clear the error state as the user types.
    document.addEventListener('input', function (e) {
      if (!e.target.matches('.quiz-v2-gate-input')) return;
      e.target.style.borderColor = '';
      e.target.style.boxShadow = '';
      var gateEl = e.target.closest('[data-quiz-v2-gate]');
      if (!gateEl) return;
      var err = gateEl.querySelector('[data-quiz-v2-gate-error]');
      if (err) { err.hidden = true; err.style.display = 'none'; }
    });

    // Gate: Enter key in a field submits.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      if (!e.target.matches('.quiz-v2-gate-input')) return;
      e.preventDefault();
      var gateEl = e.target.closest('[data-quiz-v2-gate]');
      if (!gateEl) return;
      var submit = gateEl.querySelector('.quiz-v2-gate-submit');
      if (submit) submit.click();
    });

    function go(toIndex, direction) {
      if (toIndex < 0 || toIndex >= sequence.length) return;
      sequence.forEach(function (s) {
        s.style.display = 'none';
        s.classList.remove('quiz-v2-in', 'quiz-v2-in-back');
      });
      var target = sequence[toIndex];
      target.style.display = '';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          target.classList.add(direction === 'back' ? 'quiz-v2-in-back' : 'quiz-v2-in');
        });
      });
      currentIndex = toIndex;
      updateChrome();

      // Reaching the loading slide triggers scoring + the animated build sequence (once).
      if (target.dataset.slideType === 'loading' && !resultRevealed) {
        resultRevealed = true;
        computeResult();
        runLoaderSequence(target);
      }
    }

    function next() {
      if (navLocked) return;
      navLocked = true;
      setTimeout(function () { navLocked = false; }, 380);
      go(currentIndex + 1, 'forward');
    }

    function back() {
      if (navLocked) return;
      navLocked = true;
      setTimeout(function () { navLocked = false; }, 380);
      var prev = sequence[currentIndex - 1];
      if (!prev) return;
      // Reset selection for the slide we're going BACK to
      var radios = prev.querySelectorAll('.quiz-v2-option');
      radios.forEach(function (r) { r.checked = false; });
      // Trim that response from collection
      if (prev.dataset.slideType === 'question') {
        var qid = prev.dataset.quizIndex;
        responses = responses.filter(function (r) { return r.qid !== qid; });
      }
      go(currentIndex - 1, 'back');
    }

    // ── Question option change ─────────────────────────────────────
    document.addEventListener('change', function (e) {
      if (!e.target.matches('.quiz-v2-option')) return;
      var slide = e.target.closest('[data-quiz-v2-slide]');
      if (!slide || slide.dataset.slideType !== 'question') return;
      // Visual checked state
      slide.querySelectorAll('.qes-inp-checked').forEach(function (c) { c.classList.remove('active'); });
      var parent = e.target.closest('.quiz-question-single-block');
      if (parent) {
        var c = parent.querySelector('.qes-inp-checked');
        if (c) c.classList.add('active');
      }
      // Record/replace response
      var qid = slide.dataset.quizIndex;
      var score = e.target.dataset.score;
      var qText = e.target.dataset.questionText || '';
      var aText = e.target.dataset.answerText || '';
      var alreadyAnsweredThisQ = responses.some(function (r) { return r.qid === qid; });
      responses = responses.filter(function (r) { return r.qid !== qid; });
      responses.push({ qid: qid, question: qText, answer: aText, score: score });
      // Track first start + each answer
      if (responses.length === 1 && !alreadyAnsweredThisQ) {
        track('quiz_v2_started', {});
      }
      track('quiz_v2_question_answered', {
        question_index: questionSlides.indexOf(slide) + 1,
        question_text: qText,
      });
      setTimeout(next, 280);
    });

    // Click already-selected radio → forward
    document.addEventListener('click', function (e) {
      var block = e.target.closest('.quiz-question-single-block');
      if (!block) return;
      var inp = block.querySelector('.quiz-v2-option');
      if (!inp || !inp.checked) return;
      var slide = block.closest('[data-quiz-v2-slide]');
      if (!slide || sequence.indexOf(slide) !== currentIndex) return;
      setTimeout(next, 200);
    });

    // Back buttons
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.quiz-back-svg_in, .quiz-back-svg')) return;
      back();
    });

    // ── Email + Name validation ────────────────────────────────────
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    function validateForm(form) {
      var inputs = form.querySelectorAll('.quiz-form-input');
      var ok = true;
      inputs.forEach(function (input) {
        var v = (input.value || '').trim();
        var bad = !v || (input.type === 'email' && !EMAIL_RE.test(v));
        if (bad) {
          ok = false;
          input.style.borderColor = '#FF4444';
          input.classList.add('quiz-input-error');
          input.style.animation = 'none';
          setTimeout(function () { input.style.animation = 'quizV2Shake 0.3s ease'; }, 10);
        } else {
          input.style.borderColor = '';
          input.classList.remove('quiz-input-error');
        }
      });
      return ok;
    }

    document.addEventListener('input', function (e) {
      if (!e.target.matches('.quiz-form-input')) return;
      var v = (e.target.value || '').trim();
      if (e.target.type === 'email' && v && !EMAIL_RE.test(v)) {
        e.target.style.borderColor = '#FF4444';
      } else {
        e.target.style.borderColor = '';
        e.target.classList.remove('quiz-input-error');
      }
    });

    function buildNote(rs, totals, type) {
      var lines = ['Pace Type: ' + type];
      lines.push(
        'Scores: chrono ' + totals.chrono +
        ', stress ' + totals.stress +
        ', sleep ' + totals.sleep +
        ', deplete ' + totals.deplete +
        ', mood ' + totals.mood +
        ', apnea ' + totals.apnea
      );
      rs.forEach(function (r, i) {
        lines.push('Q' + (i + 1) + ': ' + r.question);
        lines.push('A: ' + r.answer);
      });
      return lines.join('\n');
    }

    function showFormError(form) {
      var err = form.querySelector('.quiz-v2-error');
      if (!err) {
        err = document.createElement('div');
        err.className = 'quiz-v2-error';
        var btn = form.querySelector('.quiz-v2-submit');
        if (btn && btn.parentNode) { btn.parentNode.insertBefore(err, btn); }
        else { form.appendChild(err); }
      }
      err.textContent = 'Something went wrong sending that. Please try again.';
      err.style.display = '';
    }

    function showFormConfirmation(form) {
      form.innerHTML = '<div class="quiz-form-desc" style="margin:0">Thanks. Your plan is on its way to your inbox.</div>';
    }

    // ── Optional email capture on the result slide ──────────────────
    // Shopify Forms app intercepts submit events, so we use a type=button +
    // click and POST to /contact directly.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.quiz-v2-submit');
      if (!btn) return;
      var form = btn.closest('form.quiz-v2-customer-form');
      if (!form) return;
      e.preventDefault();
      if (!validateForm(form)) return;
      if (formSubmitted) return;
      formSubmitted = true;

      var nameInput = form.querySelector('[data-quiz-v2-name]');
      var emailInput = form.querySelector('[data-quiz-v2-email]');
      var consentInput = form.querySelector('[data-quiz-v2-consent]');
      var name = nameInput ? nameInput.value.trim() : '';
      var email = emailInput ? emailInput.value.trim() : '';
      var consent = consentInput ? consentInput.checked : true;

      // Use the pace type / tag / note already computed at the loading step.
      var tagsInput = form.querySelector('[data-quiz-v2-tags]');
      var noteInput = form.querySelector('[data-quiz-v2-note]');
      if (tagsInput) tagsInput.value = tag;
      if (noteInput) noteInput.value = note;
      // If consent unchecked, remove the marketing field from submission.
      if (consentInput && !consent) consentInput.disabled = true;

      // Clear any prior error + lock the button while sending.
      var priorErr = form.querySelector('.quiz-v2-error');
      if (priorErr) priorErr.style.display = 'none';
      btn.disabled = true;

      // Persist to localStorage (harmless)
      try {
        localStorage.setItem('quizV2Submission', JSON.stringify({
          name: name,
          email: email,
          paceType: paceType,
          tag: tag,
          submittedAt: new Date().toISOString(),
          responses: responses,
        }));
      } catch (_) {}

      track('quiz_v2_lead_captured', {
        pace_type: paceType,
        tag: tag,
        email: email,
        name: name,
      });

      // Klaviyo identify + "Completed Energy Quiz" firing has MOVED to the gate
      // (captureLead) so it happens once, at the gate, before the result reveal.
      // This handler is retained only for the now-hidden results form and no
      // longer fires the Klaviyo capture.

      // AJAX submit as URL-encoded — Shopify's AJAX path that accepts contact[tags]/[note].
      // Exclude form_key (Shopify Forms app marker that triggers tag/note stripping).
      var ajaxParams = new URLSearchParams();
      var fd = new FormData(form);
      fd.forEach(function (v, k) {
        if (k === 'form_key') return;
        ajaxParams.append(k, v);
      });
      fetch(form.action, {
        method: 'POST',
        body: ajaxParams.toString(),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          'Accept': 'application/json, text/javascript, */*; q=0.01',
          'X-Requested-With': 'XMLHttpRequest',
        },
      }).then(function (r) {
        if (!r.ok) throw new Error('Contact submit failed with status ' + r.status);
        showFormConfirmation(form);
      }).catch(function (err) {
        console.error('[quiz-v2] /contact failed', err);
        formSubmitted = false;
        btn.disabled = false;
        if (consentInput) consentInput.disabled = false;
        showFormError(form);
      });
    });

    function revealResult(paceTypeArg) {
      if (resultShown) return; // never reveal twice (gate submit + skip, etc.)
      resultShown = true;
      // Hide all sequence slides
      sequence.forEach(function (s) { s.style.display = 'none'; });
      // Hide quiz chrome (logo + progress bar) but reveal SITE header for navigation back
      if (quizHeader) quizHeader.style.display = 'none';
      if (quizProgressBar) quizProgressBar.style.display = 'none';
      document.body.classList.add('quiz-v2-result-shown');

      var match = resultSlides.filter(function (s) { return s.dataset.resultType === paceTypeArg; })[0];
      if (!match) match = resultSlides[0];
      if (!match) return;

      // Track completion (result shown)
      track('quiz_v2_completed', { pace_type: paceTypeArg });

      match.removeAttribute('hidden');
      match.style.display = '';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          match.classList.add('quiz-v2-in');
        });
      });

      // Conditionally reveal the doctor / safety note.
      var showDoc = (paceTypeArg === 'reset') || moodFlag || apneaFlag;
      var doc = match.querySelector('.quiz-v2-doctor-note');
      if (doc) {
        if (showDoc) doc.removeAttribute('hidden');
        else doc.setAttribute('hidden', 'hidden');
      }

      // Initialize swiper(s) if present — a result can have more than one product row
      // (e.g. a primary "Where a product fits" plus an optional tier).
      if (window.Swiper) {
        match.querySelectorAll('.quiz-product-slider').forEach(function (sliderEl) {
          try {
            new window.Swiper(sliderEl, {
              slidesPerView: 1.1,
              spaceBetween: 24,
              speed: 800,
              breakpoints: { 768: { slidesPerView: 2 } },
            });
          } catch (_) {}
        });
      }

      // Scroll to top of result
      window.scrollTo({ top: match.offsetTop - 20, behavior: 'smooth' });
    }

    // ── Bundle "Add Both to Cart" ──────────────────────────────────
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.quiz-v2-bundle-add');
      if (!btn) return;
      e.preventDefault();
      if (btn.dataset.busy === '1') return;

      var slide = btn.closest('[data-quiz-v2-slide]');
      if (!slide) return;
      var cards = slide.querySelectorAll('[data-quiz-v2-variant-id]');
      var items = [];
      var variantIds = [];
      cards.forEach(function (c) {
        var id = c.getAttribute('data-quiz-v2-variant-id');
        if (id) {
          items.push({ id: parseInt(id, 10), quantity: 1 });
          variantIds.push(id);
        }
      });
      if (items.length === 0) return;

      track('quiz_v2_bundle_added', {
        pace_type: slide.dataset.resultType || '',
        variant_ids: variantIds,
        product_count: items.length,
        has_discount: !!btn.getAttribute('data-discount-code'),
      });

      var discount = btn.getAttribute('data-discount-code');
      var label = btn.querySelector('.quiz-v2-bundle-text');
      var originalLabel = label ? label.textContent : btn.textContent;
      btn.dataset.busy = '1';
      btn.disabled = true;
      if (label) label.textContent = 'Adding…';

      var goingToDiscountUrl = !!discount;

      function resetButton() {
        btn.dataset.busy = '';
        btn.disabled = false;
        if (label) label.textContent = originalLabel;
      }

      // Single batched add — request the cart-drawer + cart-icon-bubble sections back in the response.
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: items,
          sections: goingToDiscountUrl ? undefined : ['cart-drawer', 'cart-icon-bubble'],
          sections_url: '/cart',
        }),
      })
        .then(function (r) {
          if (r.ok) return r.json();
          return r.json().then(function (err) { console.error('[quiz-v2] /cart/add.js error:', err); throw err; });
        })
        .then(function (data) {
          if (goingToDiscountUrl) {
            window.location.href = '/discount/' + encodeURIComponent(discount) + '?redirect=/cart';
            return;
          }
          var sections = data.sections || {};
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents({ sections: sections });
          } else if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else {
            window.location.href = '/cart';
            return;
          }
          // Update cart icon bubble in case renderContents didn't.
          if (sections['cart-icon-bubble']) {
            var bubbles = document.querySelectorAll('#cart-icon-bubble');
            bubbles.forEach(function (b) {
              var html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
              var fresh = html.querySelector('#cart-icon-bubble');
              if (fresh) b.innerHTML = fresh.innerHTML;
            });
          }
          resetButton();
        })
        .catch(function (err) {
          console.error('[quiz-v2] Bundle add failed:', err);
          resetButton();
          var msg = (err && err.description) || (err && err.message) || 'Could not add the items to cart.';
          alert(msg);
        });
    });

    updateChrome();
  }
})();
